import React from "react";
import { FreeMode, Mousewheel, Scrollbar } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css/scrollbar'

const MainFiltersItemScrollable = ({
  parentSwiper,
  category,
  filters,
  queryValue,
  searchParams,
  handleCheckboxChange,
  clearQueryParams,
}) => {
  const filterType =
    category === "Prize Value" || category === "Price Range"
      ? "radio"
      : "checkbox";

  const getIsChecked = (query, filter) => {
    if (searchParams.get(query)) {
      return searchParams.get(query).split(",").includes(filter.value);
    } else return false;
  };

  const stopParent = () => (parentSwiper.current.enabled = false);
  const startParent = () => (parentSwiper.current.enabled = true);

  return (
    <fieldset
      className="main-content__filters-dropdown"
      onMouseEnter={stopParent}
      onMouseLeave={startParent}
    >
      <Swiper
        className="main-content__filters-dropdown-slider"
        direction={"vertical"}
        slidesPerView={"auto"}
        freeMode={true}
        mousewheel={{
        releaseOnEdges: true
      }}
        scrollbar={{
          draggable: true,
          snapOnRelease: false
        }}
        modules={[FreeMode, Mousewheel, Scrollbar]}
        height={200}
        onTouchStart={stopParent}
        onTouchEnd={startParent}
      >
        <SwiperSlide className="">
          <p className="main-content__filters-dropdown-switch">
            {filters.map((filter) => (
              <React.Fragment key={filter.value}>
                <input
                  type={filterType}
                  id={queryValue + filter.value}
                  name={queryValue}
                  value={filter.value}
                  checked={getIsChecked(queryValue, filter)}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor={queryValue + filter.value}>{filter.name}</label>
              </React.Fragment>
            ))}
          </p>
        </SwiperSlide>
      </Swiper>
      <button
        type="button"
        className="main-content__filters-dropdown-clear"
        onClick={() => clearQueryParams(queryValue)}
      >
        Clear all
      </button>
    </fieldset>
  );
};

export default MainFiltersItemScrollable;
